import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function SelectCompany() {
  const { companies, setActiveCompany } = useAuth();
  const navigate = useNavigate();

  function handleSelect(company) {
    setActiveCompany(company);
    navigate("/dashboard", { replace: true });
  }

  return (
    <div style={{ maxWidth: 448, margin: "96px auto 0", padding: "0 16px" }}>
      <div style={{ background: "white", borderRadius: 12, border: "1px solid #d0dcea", padding: "24px" }}>
        <h2 style={{ fontSize: 18, fontWeight: 700, color: "#1e3a5f", margin: "0 0 8px" }}>Select company</h2>
        <p style={{ fontSize: 14, color: "#6b8cae", margin: "0 0 24px" }}>
          Your account is linked to multiple companies. Which one do you want to work in?
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {companies?.map((c) => (
            <button
              key={c.id}
              onClick={() => handleSelect(c)}
              style={{
                width: "100%", textAlign: "left", padding: "12px 16px",
                border: "1px solid #d0dcea", borderRadius: 8,
                background: "white", cursor: "pointer",
              }}
            >
              <div style={{ fontWeight: 500, fontSize: 14, color: "#1e3a5f" }}>{c.name}</div>
              <div style={{ fontSize: 12, color: "#6b8cae", textTransform: "capitalize" }}>{c.role_in_company}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
